import IMieiAnnunci from "./IMieiAnnunci";

export default IMieiAnnunci;
